<template>
  <div class="white-container">
    <v-server-table
      :foo="'foo'"
      ref="appTable"
      :name="name"
      :columns="columns"
      :options="options"
      @loaded="loading = false"
      @loading="loading = true"
      @pagination="pageChanged"
    >
      <template slot="beforeFilter" class="d-flex flex-column">
        <h3 class="w-100 mb-4">
          {{ title }}
        </h3>
        <b-row class="w-100 no-gutters">
          <filters
            style="width: 320px; max-width: 100%"
            :inputs="filters"
            @filter="filterUsers"
            :extend-button="false"
            :extended="true"
            :inputs-width="12"
          />
        </b-row>
        <b-row v-if="!exclude" class="w-100">
          <b-col class="flex-row flex-nowrap">
            <b-button
              :disabled="!userIds.length > 0"
              @click="addUserToTeam(false)"
            >
              {{ $t('users.attach_selected') + ' (' + userIds.length + ')' }}
            </b-button>
            <!--<b-button-->
            <!--@click="addUserToTeam(true)">-->
            <!--{{$t('users.attach_all')}}-->
            <!--</b-button>-->
          </b-col>
        </b-row>
      </template>

      <template slot="beforeLimit" v-if="totalRecordsCount > 10">
        {{ $t('global.showing') }}&nbsp;
      </template>
      <template slot="afterLimit" v-if="totalRecordsCount > 10">
        &nbsp;{{ $t('global.of_records_found', {number: totalRecordsCount}) }}
      </template>

      <template slot="id" slot-scope="props">
        <router-link :to="{path: `/users/edit/${props.row.id}`, params: props.row}" target="_blank">
          {{ props.row.id }}
        </router-link>
      </template>
      <template
        slot="subscriptions"
        slot-scope="props"
      >
        <column-subscriptions :row="props.row" column="subscriptions" />
      </template>
      <template
        v-if="!exclude"
        slot="select"
        slot-scope="props"
      >
        <column-select
          style="max-width: 40px"
          :row="props.row"
          column="select"
          :is-selected="isSelected(props.row.id)"
          @select="formSelectedUsersIds"
        />
      </template>
      <template
        v-if="exclude"
        slot="action"
        slot-scope="props"
      >
        <b-button
          variant="link"
          class="text-danger text-left w-100 p-0"
          @click="userAction(props.row.id)"
        >
          {{ $t('button.detach') }}
        </b-button>
      </template>
    </v-server-table>
  </div>
</template>


<script>
  import axios from '@/utils/axios';
  import {Event} from 'vue-tables-2';
  import filters from '@/components/global/filters';
  import i18n from "@/utils/i18n";

  export default {
    middleware: 'auth',
    name: 'Users',
    props: {
      filterField: {
        type: String
      },
      name: {
        type: String
      },
      teamId: {
        required: true
      },
      title: {
        type: String
      },
      exclude: {
        type: Boolean,
        default: false
      }
    },
    components: {
      filters
    },
    data: function () {
      let v = this;
      return {
        totalRecordsCount: null,
        rerender: false,
        userIds: [],
        filters: [
          {
            name: "users.global",
            id: "global",
            placeholder: "First Name, Email, Company, etc.",
            value: "",
            type: "text",
            label: "",
            main: false
          }
        ],
        loading: false,
        download: false,
        params: {
          page: 1
        },
        columns: ['id', 'first_name', 'last_name', 'email', 'subscriptions'],
        options: {
          columnsClasses: {select: 'column-narrow'},
          skin: [],
          headings: {
            select: i18n.t('users.select_user'),
            id: '#',
            first_name: i18n.t('users.first_name'),
            last_name: i18n.t('users.last_name'),
            email: i18n.t('users.email'),
            job: i18n.t('users.job'),
            subscriptions: i18n.t('users.subscription_info'),
            action: i18n.t('users.editing.action')
          },
          sortable: [],
          dateColumns: ['created_at'],
          columnsDropdown: false,
          filterByColumn: false,
          customFilters: ['custom'],
          filterable: false,
          requestFunction: (data) => {
            if (!data.custom) {
              data.custom = {};
            }
            data.custom[v.filterField] = this.teamId;
            return axios.get('/admin/users', {
              params: data.custom ?
                  {
                    limit: data.limit,
                    filter: data.custom,
                    page: data.page
                  } :
                  {
                    limit: data.limit,
                    page: data.page
                  }
            }).catch((e) => {
              // this.$noty.error(e.error_description);
              this.dispatch('error', e);
            });
          },
          responseAdapter: function (resp) {
            let data = this.getResponseData(resp);
            return {
              data: data.data.items,
              count: data.data.paginator.total_items
            }
          }
        },
      }
    },
    mounted() {
      this.$bus.$on('update_tables', () => {
        this.$refs.appTable.refresh()
      });
      if (!this.exclude) {
        this.columns.unshift('select')
      } else {
        this.columns = this.columns.concat(['job', 'action'])
      }
      Event.$on(`vue-tables.${this.name}.loaded`, ({data}) => {
        this.totalRecordsCount = data.paginator.total_items
        if (!this.usersFiltered && !_.isEmpty(this.$route.query)) {
          this.checkUrlParams()
        }
      });
    },
    methods: {
      isSelected(id){
        return this.userIds.indexOf(id) !== -1
      },
      pageChanged(){
        this.$refs.appTable.$el.scrollIntoView({ behavior: 'smooth' });
      },
      addUserToTeam(allUsers) {
        if (!allUsers) {
          let params;

          if (this.userIds.length) {
            params = {user_ids: this.userIds}
          } else {
            params = {
              filter: {
                active: true
              }
            }
          }

          this.postData(`teams/${this.teamId}/users`, params).then(() => {
            this.$bus.$emit('update_tables');
            this.$bus.$emit('clearCheckbox');
            this.userIds = [];
          })
        } else {
          this.postData(`teams/${this.teamId}/users`, {}).then(() => {
            this.$bus.$emit('update_tables')
          })
        }
      },
      filterUsers(params) {
        Event.$emit(`vue-tables.${this.name}.filter::custom`, params)
      },
      formSelectedUsersIds(id) {
        if (this.userIds.indexOf(id) !== -1) {
          _.pull(this.userIds, id);
          this.$forceUpdate()
        } else {
          this.userIds.push(id)
        }
      },
      userAction(userId) {
        this.deleteData(`teams/${this.teamId}/users/${userId}`).then(() => {
          this.$bus.$emit('update_tables')
        })
      }
    },
    destroyed() {
      this.$bus.$off('update_tables');
      Event.$off('vue-tables.loaded');
    }
  }
</script>